export const tokens = {
  darkGrayBlue: 'hsl(217, 19%, 35%)',
  darkBlue: 'hsl(214, 17%, 51%)',
  grayBlue: 'hsl(212, 23%, 69%)',
  lightGrayBlue: 'hsl(210, 46%, 95%)'
};
